module.exports = __webpack_public_path__ + "img/caas3-m@1.44ed7304.webp";